var map = {
	"./CLOTHE1.svg": 54614,
	"./CLOTHE10.svg": 50482,
	"./CLOTHE11.svg": 5159,
	"./CLOTHE12.svg": 78381,
	"./CLOTHE2.svg": 67842,
	"./CLOTHE3.svg": 22981,
	"./CLOTHE4.svg": 78398,
	"./CLOTHE5.svg": 27641,
	"./CLOTHE6.svg": 91278,
	"./CLOTHE7.svg": 72209,
	"./CLOTHE8.svg": 5870,
	"./CLOTHE9.svg": 6353
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 83603;